import { ConvexReactClient } from "convex/react";

const convexUrl = process.env.REACT_APP_CONVEX_URL;
if (!convexUrl) {
  throw new Error("REACT_APP_CONVEX_URL environment variable is not set");
}

export const convex = new ConvexReactClient(convexUrl);
